import { createContext, useContext, type ReactNode } from "react";
import type { KeyValueStorage } from "./KeyValueStorage";

interface PreferenceStorageContextType {
	storage: KeyValueStorage;
}

const PreferenceStorageContext =
	createContext<PreferenceStorageContextType | null>(null);

interface PreferenceStorageProviderProps {
	storage: KeyValueStorage;
	children: ReactNode;
}

export const PreferenceStorageProvider = ({
	storage,
	children,
}: PreferenceStorageProviderProps) => {
	return (
		<PreferenceStorageContext.Provider value={{ storage }}>
			{children}
		</PreferenceStorageContext.Provider>
	);
};

export const usePreferenceStorage = (): KeyValueStorage => {
	const context = useContext(PreferenceStorageContext);

	if (!context) {
		throw new Error(
			"usePreferenceStorage must be used within a PreferenceStorageProvider",
		);
	}

	return context.storage;
};
